import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const solidPrimary = defineStyle({
    background: "primary.300",
    _hover: {
        background: "primary.400",
    },
});

const solidGray = defineStyle({
    background: "gray.200",
    color: "gray.700",
    _hover: {
        background: "gray.300",
    },
});

export const buttonTheme = defineStyleConfig({
    baseStyle: {
        borderRadius: "md",
        fontWeight: "medium",
    },
    variants: {
        solid: ({ colorScheme }) => ({
            ...(colorScheme === "primary" && solidPrimary),
            ...(colorScheme === "gray" && solidGray),
        }),
        outline: ({ colorScheme }) => ({
            ...(colorScheme === "primary" && {
                color: "primary.300",
            }),
        }),
    },
    defaultProps: {
        colorScheme: "primary",
    },
});
